<template>
  <div class="fill-height">
    <Loading :loading="isLoading"></Loading>
    <topNav />
    <div class="mt-5"  style="padding-left: 15px;padding-right: 15px;">
      <h1>{{ lesson.name }}</h1>
      <b-row class="my-2 font-weight-bold" v-if="lesson.teachers.length > 0">
        <b-col>
          <span>ผู้สอน </span>
        </b-col>
      </b-row>
      <b-row>
        <div v-for="teacher in lesson.teachers" :key="teacher.id">
          <!-- teracher -->
          <div class="d-flex align-items-center py-2 pl-3" style="cursor: pointer;"
            @click="teacherDetail(teacher.user.id)">
            <!-- Avatar -->
            <b-avatar :src="teacher.user ? teacher.user.profile_image : ''" size="3rem"
              class="mr-2 flex-shrink-0"></b-avatar>

            <!-- Text (ชื่อ + ตำแหน่ง) -->
            <div class="d-flex flex-column">

              <span class="text-truncate font-weight-bold" style="font-size: 13px; color: #374151;"
                :title="teacher.user ? teacher.user.first_name + ' ' + teacher.user.last_name : ''">
                {{ teacher.user ? teacher.user.first_name + ' ' + teacher.user.last_name : '' }}
              </span>
            </div>
          </div>
        </div>

        <b-col md="3" cols="12" v-if="lesson.pdf" class="d-flex align-items-center">
          <button @click="downloadFile(lesson.pdf.url)" class="btn btn-download mx-auto">
            Download เอกสาร
          </button>
        </b-col>


        <b-col md="3" cols="12" class="mb-4" v-if="lesson.is_external_link && lesson.external_link">
          <button @click="downloadFile(lesson.external_link)" class="btn btn-light">
            ลิ้งค์ระบบภายนอก
          </button>
        </b-col>
      </b-row>
      <b-row>

      </b-row>

      <div v-if="lesson.media?.type === 'h5p' && !isLoading"> 
        <H5PPlayer :media="lesson.media" :enroll_id="courseStatus.enroll_id" :user_id="userData.id"
          :subject_id="lesson.subject_id" :lesson_id="lesson.id" :access_token="access_token"
          :lesson_status="lesson.progress?.status" :duration="lesson.media?.duration" :loading="isLoading" />
      </div>

      <b-row class="text-center" v-else>
        <b-col v-if="
          lesson.media ||
          lesson.video_lesson_id_360 > 0 ||
          lesson.video_lesson_id_480 > 0 ||
          lesson.video_lesson_id_720 > 0 ||
          lesson.video_lesson_id_1080 > 0
        " cols="12" class="my-3">
          <!-- <img style="max-width: 20%" class="absolute-img" src="../../public/logo.png" /> -->
          <video v-if="isGetContent" ref="videoNode" :id="lesson.id"
            class="video-js vjs-big-play-centered" controls playsinline></video>
        </b-col>
      </b-row>

      <b-row v-if="lesson.pdf" class="my-2">
        <b-col lg="12" md="12" sm="12" cols="12">
          <PDFView ref="pdfView" :src="lesson.pdf.url" :page="page"></PDFView>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12">
          <div>
            <b-tabs content-class="mt-5" align="left">
              <b-tab title="บทเรียน" active>
                <p v-html="lesson.description"></p>
                <b class="text-primary-100">เนื้อหาในคอร์สเรียน</b>
                <LessonList :selected="lesson" :lessons="course ? course.lessons : []" :answerCourse="answerCourse"
                  :courseStatus="courseStatus" :lessonProgress="progressResponse"
                  :enrollCheck="checkEnroll(course.enroll || [])" />
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LessonList from "@/components/Lessons/LessonList";
import img from "@/assets/image/mock/overview.png";
import topNav from "@/components/topNav.vue";
import Loading from "@/components/Loading.vue";
import PDFView from "./PDFView.vue";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      video_about: null,
      poster_video: img,
      isLoading: false,
      courseStatus: false,
      answerCourse: null,
      isGetContent: false,
      syncSlide: [],
      page: 1,
      playTime: 0,
      playTimeInterval: null,
      timer: null,
      progressResponse: null,
      firstRender: true,
      objectUrl: null,
      player: null,
      pendingSeek: null,
      seekTarget: null,
      seekCheckTimer: null,
      blobFallbackTried: false,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.Auth.userData,
      access_token: (state) => state.Auth.access_token,
      course: (state) => {
        return state.Courses.course;
      },
      lesson: (state) => {
        return state.Lessons.lessons;
      },
    }),
  },
  created() {
    this.isGetContent = false;
    this.changeFormatSyncSlide();
  },
  async mounted() {
  this.isLoading = true;
  await this.getContent();
  await this.checkCourseStatus();
  this.isLoading = false;

  await this.$nextTick();
  if (!this.$refs.videoNode) return;

  // 1. ดึง URL วิดีโอ + จุดที่เล่นค้างไว้ (อ่านจาก progress ของ server เท่านั้น)
  const videoUrl = this.getVideoSourceUrl();
  const startSec = this.getResumeSeconds();

  this.player = videojs(this.$refs.videoNode, {
    controls: true,
    preload: "auto",
    fluid: true,
    sources: [{ src: videoUrl, type: "video/mp4" }],
  });

  // 2. ถ้ามีจุดที่ค้างไว้ ให้กระโดดไปตอน metadata พร้อม
  // (ready = ตัว player พร้อม แต่ duration ยังเป็น NaN อยู่ -> สั่ง seek ไปจะโดนทิ้ง)
  if (startSec > 0) {
    this.pendingSeek = startSec;
    this.player.one("loadedmetadata", this.seekToPendingTime);
  }

  // sync slide และ event อื่นๆ คงเดิม...
  if (this.syncSlide.length > 0) {
    this.player.on("timeupdate", () => {
      this.syncSlideProcess(this.player.currentTime());
    });
  }

  let self = this;
  this.player.on("play", () => {
    this.timer = setInterval(() => {
      const currentTime = this.player.currentTime();
      const duration = this.player.duration();
      self.updateProgress(currentTime, duration);
    }, 10000);

    this.playTimeInterval = setInterval(() => {
      this.playTime++;
    }, 1);
  });

  this.player.on("pause", () => {
    clearInterval(this.timer);
    clearInterval(this.playTimeInterval);
  });

  this.player.on("ended", this.videoEnd);
},
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.playTimeInterval);
    clearTimeout(this.seekCheckTimer);
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    if (this.player) {
      this.player.dispose();
      // เคลียร์ด้วย เผื่อ loadVideoAsBlobAndResume ยัง await ค้างอยู่ตอนออกจากหน้า
      this.player = null;
    }
  },
  components: {
    LessonList,
    PDFView,
    Loading,
    topNav,
  },
  methods: {
    // เลือก URL วิดีโอมา 1 อัน (blob โหลดได้ทีละไฟล์) — multi ให้เลือกความชัดสูงสุดที่มี
    getVideoSourceUrl() {
      const l = this.lesson;
      if (l.video_lesson_is_multi == 1) {
        if (l.video_lesson_id_1080 > 0) return l.video_lesson_1080;
        if (l.video_lesson_id_720 > 0) return l.video_lesson_720;
        if (l.video_lesson_id_480 > 0) return l.video_lesson_480;
        if (l.video_lesson_id_360 > 0) return l.video_lesson_360;
      }
      return l.media ? l.media.url : null;
    },
    // จุดที่จะเล่นต่อ — อ่านจาก progress ที่ server บันทึกไว้เท่านั้น
    // ห้ามอ่านจาก query string เด็ดขาด เพราะผู้ใช้แก้ ?sec= เองเพื่อข้ามวิดีโอได้
    getResumeSeconds() {
      const list = this.progressResponse;
      const record = Array.isArray(list)
        ? list.find((p) => p.lesson_id == this.lesson.id)
        : null;

      const sec = record ? parseInt(record.lesson_time_sec) : NaN;
      return !isNaN(sec) && sec > 0 ? sec : 0;
    },
    // กระโดดไปยังจุดที่ค้างไว้ เรียกตอน metadata พร้อม
    seekToPendingTime() {
      if (!this.player || !this.pendingSeek) return;

      const duration = this.player.duration();
      if (!duration || isNaN(duration) || !isFinite(duration)) return;

      this.seekTarget = Math.min(this.pendingSeek, Math.max(duration - 1, 0));
      this.player.currentTime(this.seekTarget);
      this.verifySeek();
    },
    // server บางตัวไม่รองรับ HTTP Range (เช่น n8n webhook) สั่ง seek ไปแล้วหัวอ่านไม่ขยับ
    // เลยต้องเช็กผลจริงก่อน ค่อยถอยไปใช้วิธีโหลดทั้งไฟล์เป็น blob ซึ่งแพงกว่ามาก
    verifySeek() {
      clearTimeout(this.seekCheckTimer);

      // seek สำเร็จตามปกติ -> จบงานตั้งแต่ seeked ยิง
      this.player.one("seeked", this.onSeeked);

      this.seekCheckTimer = setTimeout(() => {
        if (!this.player || !this.pendingSeek) return;

        // ยังไปไม่ถึงแปลว่า server นี้ seek ไม่ได้
        if (this.blobFallbackTried) {
          this.pendingSeek = null;
          return;
        }
        this.blobFallbackTried = true;
        this.loadVideoAsBlobAndResume();
      }, 4000);
    },
    onSeeked() {
      if (!this.player || this.seekTarget === null) return;

      // บางเคส seeked ยิงแต่หัวอ่านเด้งกลับ 0 -> ถือว่ายังไม่สำเร็จ ปล่อยให้ timer จัดการต่อ
      if (Math.abs(this.player.currentTime() - this.seekTarget) <= 2) {
        clearTimeout(this.seekCheckTimer);
        this.pendingSeek = null;
      }
    },
    // ทางสำรองสำหรับ server ที่ไม่รองรับ Range: โหลดทั้งไฟล์มาเป็น blob แล้วเล่นจากเครื่อง — seek ได้เต็มที่
    // ข้อแม้: fetch ต้องการ CORS ส่วน <video src> ไม่ต้อง ถ้า server ไม่ส่ง CORS มาจะล้ม แล้วเล่นต่อจากวินาทีที่ 0
    async loadVideoAsBlobAndResume() {
      if (!this.player) return;

      const url = this.getVideoSourceUrl();
      if (!url) return;

      try {
        this.isLoading = true;

        const resp = await fetch(url);
        if (!resp.ok) throw new Error("HTTP " + resp.status);

        const blob = await resp.blob();
        if (!this.player) return; // ออกจากหน้าไปก่อนโหลดเสร็จ

        this.objectUrl = URL.createObjectURL(blob);
        this.player.one("loadedmetadata", this.seekToPendingTime);
        this.player.src({ src: this.objectUrl, type: "video/mp4" });
      } catch (e) {
        // ส่วนใหญ่คือ CORS — วิดีโอเล่นได้ต่อตามปกติ แค่เริ่มที่ 0
        // eslint-disable-next-line no-console
        console.warn("resume ด้วย blob ไม่สำเร็จ เล่นต่อจากต้นคลิป:", e);
        this.pendingSeek = null;
      } finally {
        this.isLoading = false;
      }
    },
    isShowPlayer() {
      return !this.isLoading;
    },
    async updateProgress(currentTime, duration) {

      const model = {
        user_id: this.userData.id,
        subject_id: this.lesson.subject_id,
        lesson_id: this.lesson.id,
        lesson_time_sec: currentTime,
        duration: duration,
        enroll_id: this.courseStatus.enroll_id,
        play_time: this.playTime,
      };
      this.$store
        .dispatch("Lessons/saveLessonProgress", {
          model,
          accessToken: this.access_token,
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("Auth/logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    // Change Page when Video play to the page time
    async syncSlideProcess(currentTime) {
      this.syncSlide.forEach((model, index) => {
        if (index + 1 < this.syncSlide.length) {
          if (
            currentTime >= this.syncSlide[index].total_second &&
            currentTime <= this.syncSlide[index + 1].total_second
          ) {
            if (this.page != model.page) {
              this.page = model.page;
            }
            return;
          }
        } else {
          if (currentTime >= this.syncSlide[index].total_second) {
            if (this.page != model.page) {
              this.page = model.page;
            }
            return;
          }
        }
      });
    },

    // Prepare
    changeFormatSyncSlide() {
      if (this.lesson.sync_slide) {

        this.syncSlide = JSON.parse(this.lesson.sync_slide);
        this.syncSlide = this.syncSlide.map((x) => {
          let page = parseInt(x.page);
          let total_second = parseInt(x.total_second);
          return { page: page, total_second: total_second };
        });
        this.syncSlide.sort(function (a, b) {
          return a.total_second - b.total_second;
        });
      }
    },

    async teacherDetail(id) {
      let path = `/teacher-detail`;
      await this.$router.push({
        path: path,
        query: { id: id },
      });
    },
    async checkCourseStatus() {
      const model = {
        user_id: this.userData.id,
        subject_id: this.course.id,
      };

      let courseResponse;
      try {
        courseResponse = await this.$store.dispatch(
          "Courses/checkCourseStatus",
          {
            model,
            accessToken: this.access_token,
          }
        );

        this.courseStatus = courseResponse;
        if (this.courseStatus) {
          if (this.courseStatus.isBan) {
            let path = `/courses`;
            await this.$router.push({
              path: path,
              query: { id: this.$route.query.courseId },
            });
          }
        }
      } catch (err) {
        this.isLoading = false;
        this.courseStatus = null;
      }

      let answerResponse;
      try {
        answerResponse = await this.$store.dispatch("Courses/getCourseAnswer", {
          id: this.course.id,
          accessToken: this.access_token,
          enrollId: this.courseStatus.enroll_id,
        });

        this.answerCourse = answerResponse;
      } catch (err) {
        this.isLoading = false;
        this.answerCourse = false;
      }

      await this.getLessonProgress();
    },
    downloadFile(link) {
      window.open(link, "_blank");
    },
    async getContent() {
      const course = this.$route.query.courseId;
      const lesson = this.$route.query.lessonId;
      if (course || lesson) {
        await this.$store.dispatch("Courses/getCourse", {
          id: course,
          user_id: this.userData.id,
        });
        await this.$store.dispatch("Lessons/getLessons", lesson);

        this.$forceUpdate();
        this.isGetContent = true;
      } else {
        this.$router.push("/");
      }
    },
    async getLessonProgress() {
      let progressResponse;
      try {
        progressResponse = await this.$store.dispatch(
          "Courses/onGetLessonProgess",
          {
            subjectId: this.course.id,
            enrollId: this.courseStatus.enroll_id,
            accessToken: this.access_token,
          }
        );

        this.progressResponse = progressResponse;
      } catch (error) {
        this.progressResponse = false;
      }
    },
    checkEnroll(enrolls) {
      let rs = false;

      if (!Array.isArray(enrolls) || (enrolls && enrolls.length === 0)) {
        this.noEnroll = true;
        rs = false;
      } else {
        const enrollsActive = enrolls.filter((enroll) => enroll.status);
        if (enrollsActive && enrollsActive.length <= 0) {
          rs = false;
        } else {
          const now = moment();
          // enrollsActive.forEach((enroll) => {
          const enroll = enrolls[0];
          const start_at = moment(enroll.register_start);
          const end_at = moment(enroll.register_end);

          const course_start_at = moment(enroll.course_start);
          const course_end_at = moment(enroll.course_end);

          if (now.isBetween(start_at, end_at) && now.isBetween(course_start_at, course_end_at)) {

            // if( (start_at && end_at) && (course_start_at && course_end_at) ){
            if (this.course.access_rights === 'public' || (this.course.access_rights === 'private' && this.course.approve_right !== null)) {

              if (enroll.user_enroll && enroll.user_enroll.length > 0 && course_end_at.isAfter(now)) {
                rs = true;
              } else if (enroll.user_enroll && enroll.user_enroll.length == 0 && end_at.isAfter(now)) {
                rs = false;
              }
            }
          }
          // });
        }
      }
      return rs;
    },
    videoEnd() {
      location.reload();
    }
  },
};
</script>

<style>
.absolute-img {
  position: absolute;
  z-index: 500;
  width: 120px;
  top: 4%;
  right: 4%;
}
</style>
